import { beepVolume, longBeepDuration, shortBeepDuration, verbose } from "./constants";
import { BarcodeDataType } from "./types";

export const beepWarning = () => {
  if (!window.EB?.Notification) return;

  const timeoutDuration = longBeepDuration * 1.1;
  try {
    window.EB.Notification.beep({ volume: beepVolume, duration: longBeepDuration });

    setTimeout(() => {
      window.EB?.Notification?.beep({ volume: beepVolume, duration: longBeepDuration });
    }, timeoutDuration * 2);

    setTimeout(() => {
      window.EB?.Notification?.beep({ volume: beepVolume, duration: longBeepDuration });
    }, timeoutDuration * 4.25);
  } catch (err) {}
};

export const beepOk = () => {
  if (!window.EB?.Notification) return;
  try {
    window.EB.Notification.beep({ volume: beepVolume, duration: shortBeepDuration });
  } catch (err) {}
};

// Console-only logger. The `push` and `data` params are kept so existing call
// sites keep compiling; remote logging to the API has been removed.
export const appLog = async (
  message: string,
  _push: boolean = false,
  level: string = "info",
  _data: object | string = {}
) => {
  if (verbose) {
    console.log(`[${level.toUpperCase()}] ${message}`);
  }
};

// Utility functions
export const hasQRcodeNumberPattern = (input: string): boolean => {
  if (!input || input.length === 0) {
    return false;
  }
  const pattern = /^(?:\d{32,}|\d \d+)(?: \d \d+)*$/;
  return pattern.test(input.trim());
};

// The format used on qr-codes on labels is a DataLabelType followed by an encoded enity id
// for example `1 10815369844800064852055837985021573969 4 64 5 285046170690173140960999268114314607717`
// The last DataLabelType will indicate if it is a qr-code on a product, bag or bin
export const barcodeDataTypeFromQrCode = (input: string): BarcodeDataType | null => {
  if (!input || input.length === 0) {
    return null;
  }
  const sliced = input.split(" ");
  if (sliced.length < 2) {
    return null;
  }
  return Number(sliced[sliced.length - 2]) as BarcodeDataType;
};
